<div class="sc-ngx-checkbox">
  <div class="checkbox">
    <label [tabindex]="scTabindex" (keypress)="onKeyPress($event)">
      <input type="checkbox"
             [ngModel]="isChecked"
             (ngModelChange)="onCheckboxChange($event)"
             (click)="onClick()"
             [disabled]="isDisabled"
             [required]="required"
             [attr.checked]="isChecked==true?true:null" />

      <span class="cr"><i class="cr-icon fa fa-check" aria-hidden="true"></i></span>
      <span class="cr-label input-label" *ngIf="scLabel">
        {{ scLabel }}
      </span>
    </label>
  </div>
</div>
